var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationSection = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
const navigation_section_footer_var_1 = require("./navigation-section-footer-var");
const navigation_section_header_var_1 = require("./navigation-section-header-var");
const navigation_section_sitemap_var_1 = require("./navigation-section-sitemap-var");
const componentList = {
    header: navigation_section_header_var_1.NavigationSectionHeaderVar,
    footer: navigation_section_footer_var_1.NavigationSectionFooterVar,
    sitemap: navigation_section_sitemap_var_1.NavigationSectionSitemapVar,
};
exports.NavigationSection = (props) => {
    const Variation = core_1.getVariation(props, componentList);
    return react_1.default.createElement(Variation, Object.assign({}, props));
};
//# sourceMappingURL=navigation-section.js.map